import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { AddToFavouritesResponse } from '../interfaces/add-to-favourite.interface';

@Injectable({
  providedIn: 'root',
})
export class AddToFavouritesService extends ApiService {
  public addData(reqData: any): Observable<AddToFavouritesResponse> {
    return this.post<AddToFavouritesResponse>(ROUTES.REACH_ADD_FAV, {
      body: reqData,
    });
  }
  public getData(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.REACH_GET_FAV_DATA, {
      params: reqData,
    });
  }
  public delData(id: any): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.REACH_DELETE_DATA_FAV, {
        memKey: id,
      })
    );
  }
}
